const swagger = {
    invalid_zod_type: 'نوع Zod نامعتبر است. لطفاً پیکربندی route guard را بررسی کنید.',
    not_supported_zod_type_for_params: 'نوع Zod برای پارامترها پشتیبانی نمی‌شود. لطفاً پیکربندی route guard را بررسی کنید.',
};
export default Object.freeze(swagger);
